<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSupportAgent_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <mask
        id="IconSupportAgent_16__a"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
    >
        <path fill="currentColor" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#IconSupportAgent_16__a)">
        <path
            fill="currentColor"
            d="M7.333 14v-1.333h5.334V7.933q0-1.95-1.359-3.308T8 3.267 4.692 4.625 3.333 7.933V12h-.666q-.55 0-.942-.392a1.28 1.28 0 0 1-.392-.941V9.333q0-.35.175-.658T2 8.183l.05-.883a5.8 5.8 0 0 1 .658-2.1 6.3 6.3 0 0 1 1.317-1.683A5.9 5.9 0 0 1 5.842 2.4 5.9 5.9 0 0 1 8 2q1.133 0 2.15.4a5.985 5.985 0 0 1 3.133 2.783 6.1 6.1 0 0 1 .667 2.1l.05.867q.317.15.492.45t.175.633v1.534q0 .333-.175.633-.176.3-.492.45v.817q0 .55-.392.941a1.28 1.28 0 0 1-.941.392z"
        />
    </g>
</svg>
